import { GeneralFilterComponent } from './../../../../shared/general-filter.component';
import { FormularioService } from './../../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';
import { GeneralService } from 'src/app/services/general.service';
import { FormHumidityFilter } from 'src/app/entity/models/form-humidity-filter';

@Component({
    selector: 'app-form-humidity-filter',
    templateUrl: './humidity-filter.component.html',
    styleUrls: ['./humidity-filter.component.scss']
})
export class HumidityFilterComponent extends GeneralFilterComponent implements OnInit {

    public formulario?: FormGroup;


    @Output() filter = new EventEmitter();

    constructor(protected formBuilder: FormBuilder, protected formularioService: FormularioService,
        // tslint:disable-next-line: align
        protected notificationService: NotificationService, protected generalService: GeneralService) {
        super();
        this.formulario = this.formBuilder.group({  
            hibrido: ['', []],
            safra: ['', []],
            padrao_percentil: ['', []],
            umidade_maxima: ['', []],

        });
    }

    async ngOnInit(): Promise<void> {


    }

    async sendFilter(): Promise<void> {
        this.filter.emit(await this.buildFilter());
    }

    async clearFilter(): Promise<void> {
        this.formulario.reset();
    }

    async buildFilter(): Promise<FormHumidityFilter> {
        const formulario: FormHumidityFilter = new FormHumidityFilter();
        formulario.hibrido = this.formulario.get('hibrido')?.value;
        formulario.safra = this.formulario.get('safra')?.value;
        formulario.padrao_percentil = this.formulario.get('padrao_percentil')?.value;
        formulario.umidade_maxima = this.formulario.get('umidade_maxima')?.value;
        return formulario;
    }



}
